'use client';

import { c as _c } from "react/compiler-runtime";
import { INTERACTIVE_SURFACE } from '@common/components/interaction';
import { cn } from '@core/utils';
import { AnimatePresence, motion } from 'framer-motion';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES, ROUTES } from '@/constants';
type ServiceKey = 'wello' | 'donation';
interface ServiceItem {
  key: ServiceKey;
  label: string;
  href: string;
  iconSrc: string;
}
const SERVICE_ITEMS: Record<ServiceKey, ServiceItem> = {
  wello: {
    key: 'wello',
    label: '웰로',
    href: ROUTES.HOME.pathname,
    iconSrc: '/assets/svgs/brand/wello-badge.png'
  },
  donation: {
    key: 'donation',
    label: '고향사랑기부',
    href: DONATION_ROUTES.HOME.pathname,
    iconSrc: '/assets/svgs/brand/donation-badge.png'
  }
};
interface ServiceSwitchDropdownProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
}
export const ServiceSwitchDropdown = t0 => {
  const $ = _c(7);
  const {
    isOpen,
    onClose,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.values(SERVICE_ITEMS);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const items = t1;
  let t2;
  if ($[1] !== className || $[2] !== isOpen || $[3] !== onClose) {
    t2 = isOpen ? <><motion.div aria-hidden={true} className="fixed inset-0 z-40 bg-Gray-black/50" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15
      }} onClick={onClose} /><motion.div className={cn("shadow-large absolute bottom-full left-0 z-50 mb-12 min-w-160 rounded-small bg-Gray-white px-16 py-12", className)} initial={{
        opacity: 0,
        y: 8,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.95
      }} transition={{
        type: "spring",
        stiffness: 500,
        damping: 35
      }} role="menu" aria-label={"\uB2E4\uB978 \uC11C\uBE44\uC2A4\uB85C \uC774\uB3D9"}><ul className="flex flex-col gap-4">{items.map(t3 => {
            const {
              key,
              label,
              href,
              iconSrc
            } = t3;
            return <li key={key}><CustomLink href={href} onClick={onClose} className={cn("-mx-8 flex items-center gap-8 rounded-xsmall px-8", INTERACTIVE_SURFACE)} role="menuitem"><Image alt="" aria-hidden={true} className="size-32 shrink-0 rounded-medium" src={iconSrc} width={32} height={32} /><span className="font-500 text-Gray-900 typo-body4">{label}</span></CustomLink></li>;
          })}</ul></motion.div></> : null;
    $[1] = className;
    $[2] = isOpen;
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <AnimatePresence>{t2}</AnimatePresence>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};